<template>
  <div>
    <div class="columns is-multiline dashboard-div" v-if="visible">
      <!-- 전체, 파트너별 선택 탭 -->
      <div class="column is-full flex" style="padding:12px">
        <div class="unselect tab-item" :class="{'tab-item-selected': selectedTab===0}" @click="clickTab(0)">전체</div>
        <div class="unselect tab-item" :class="{'tab-item-selected': selectedTab===1}" @click="clickTab(1)">파트너별</div>
        <div v-if="selectedTab===1">
          <div class="select-partner">
            <select v-model="tabPartnerId" @change="onChange">
              <option v-for="partner in partners" :key="'partner-'+partner.value"
                :value="partner.value">{{ partner.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="column" :class="'is-12'" v-if="value">
        <div class="columns is-multiline">
          <div class="column is-12">
            <!-- 패키지 선택 탭 -->
            <div class="panel-tab" v-if="value.pack_panels.length>1">
              <div class="unselect panel-tab-item"
                   :class="{'panel-tab-item-selected': panel.package === selectedPanel.package}"
                   v-for="(panel,idx) in value.pack_panels" :key="'pack-'+idx"
                   @click="selectedPanel=panel">{{ panel.package_kor }}</div>
            </div>
            <!-- 오늘 매출 현황 -->
            <template v-if="selectedPanel.daily.order">
              <div class="lp-dashboard-title">오늘 매출 현황</div>
              <div class="lp-dashboard-content unselect">
                <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.order.url)">
                  <div class="panel-daily-title">주문({{ selectedPanel.daily.order.count }}건)</div>
                  <div class="panel-daily-price">{{ selectedPanel.daily.order.price|currency }}</div>
                </div>
                <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.pay.url)">
                  <div class="panel-daily-title">결제({{ selectedPanel.daily.pay.count }}건)</div>
                  <div class="panel-daily-price">{{ selectedPanel.daily.pay.price|currency }}</div>
                </div>
                <div class="lp-panel-box column is-4" @click="routerPush(selectedPanel.daily.refund.url)">
                  <div class="panel-daily-title">환불({{ selectedPanel.daily.refund.count }}건)</div>
                  <div class="panel-daily-price">{{ selectedPanel.daily.refund.price|currency }}</div>
                </div>
              </div>
            </template>
            <!-- 주문 관리 -->
            <template v-if="selectedPanel.order_manages.length>0">
              <div class="lp-dashboard-title">주문 관리</div>
              <div class="lp-dashboard-content unselect wrap">
                <div v-for="(orderItem,idx) in selectedPanel.order_manages" :key="'order-item-'+idx"
                     class="lp-panel-content">
                  <div class="lp-panel-box" @click="routerPush(orderItem.url)">
                    <div class="lp-content-box-title">{{ orderItem.name }}</div>
                    <div class="lp-content-box-data">{{ orderItem.count }}</div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 취소/환불 관리 -->
            <template v-if="selectedPanel.refund_manages.length>0">
              <div class="lp-dashboard-title">취소/환불 관리</div>
              <div class="lp-dashboard-content unselect wrap">
                <div v-for="(refundItem,idx) in selectedPanel.refund_manages" :key="'refund-item-'+idx"
                     class="lp-panel-content">
                  <div class="lp-panel-box" @click="routerPush(refundItem.url)">
                    <div class="lp-content-box-title">{{ refundItem.name }}</div>
                    <div class="lp-content-box-data">{{ refundItem.count }}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- 주문이 가장 많은 상품 TOP 5 -->
          <div class="column is-6" v-if="value.populate.length>0">
            <div class="lp-dashboard-title">주문이 가장 많은 상품 TOP 5<span style="font-size:12px;margin-left:8px">*최근 1개월 기준</span></div>
            <div class="lp-dashboard-content" style="display: block">
              <div v-for="(item,idx) in value.populate" :key="'populate-item-'+idx"
                   class="unselect card-top-product" @click="clickPopulate(item)">
                <div>
                  <img style="width:36px;height:36px;object-fit: cover" :src="item.first_img">
                </div>
                <div style="flex:1;padding:0 8px">
                  <div class="card-top-product-name">{{ item.name }}</div>
                  <div class="card-top-product-partner-name">{{ item.partner_name }}</div>
                </div>
                <div class="has-text-centered">
                  <div>주문수</div>
                  <div>{{ item.count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import chart from '../../../LineChart.js'
  export default {
    layout: 'Main',
    name: 'SuperVisorDashboard',
    components: {
      chart
    },
    computed: {
      serviceName() {
        return this.$store.getters.serviceName;
      }
    },
    created() {
      this.getData();
      this.getPartners();
      /*if(this.isAdmin){

        this.getNotice();
      }*/
    },
    data() {
      return {
        selectedTab: 0,
        tabPartnerId: 0,
        partners: [],
        value: {},
        // 차트
        chartData: {},
        disk_usage: 0,
        service_s3bucket: 0,
        launchpack_s3bucket: 0,
        // 공지사항
        notice: [],
        // 1:1 문의
        customer: [],
        visible: false,
        selectedPanel: undefined
      }
    },
    methods:{
      isPack(pack_name) {
        let value = find(this.$store.getters.getPackages, 'name', pack_name);
        if(value!==undefined) return true;
        else return false;
      },
      getPartners() {
        this.$axios.get(this.getUrl('partner/simple')).then(res=>{
          this.partners = res.data;
          this.tabPartnerId = this.partners.length > 0 ? this.partners[0].value : 0;
        });
      },
      clickTab(i) {
        if(this.selectedTab !== i) {
          this.selectedTab = i;
          this.getData();
          this.getChartData();
        } else {
          this.selectedTab = i;
        }
      },
      onChange() {
        this.getData();
      },
      getData(){
        let url = 'dashboard';
        if(this.selectedTab === 1 && this.tabPartnerId !== 0) {
          url += `?partner_id=${this.tabPartnerId}`;
        }
        this.$axios.get(this.getUrl(url)).then(res=>{
          if(res.status===200){
            this.value = res.data;
            if(!this.selectedPanel)
              this.selectedPanel = this.value.pack_panels[0];
            else {
              let sel = this.value.pack_panels.filter(item=>{ return item.package === this.selectedPanel.package });
              if(sel.length>0) {
                this.selectedPanel = sel[0];
              } else {
                this.selectedPanel = this.value.pack_panels[0];
              }
            }
            this.visible = true;
          }
        })
      },
      clickCustomerInquiry() {
        if(this.isAdmin) {
          this.$router.push(this.getPath('launchpack/inquiry/customer'));
        }
      },
      clickCustomerInquiryDetail(id) {
        if(this.isAdmin) {
          this.$router.push(this.getPath('launchpack/inquiry/customer/create?id='+id));
        }
      },
      getNotice(){
        // let key = this.$store.getters.getServiceSetting.service_key;
        /*this.$axios.get(this.masterBackendUrl + 'public/launchpack/notice', {
          params: {
            key: key
          }
        }).then(res=>{
          this.notice = res.data.data;
        })*/
        this.$axios.get('admin/launchpack/notice').then(res=>{
          this.notice = res.data.data;
        })
      },
      clickNotice(){
        if(this.isAdmin) {
          this.$router.push(this.getPath('launchpack/notice'));
        }
      },
      clickNoticeDetail(id) {
        if(this.isAdmin) {
          this.$router.push(this.getPath('launchpack/notice/create?id='+id));
        }
      },
      clickPost(post){
        this.$router.push(this.getPath(`board/${post.board_id}/post?title=${post.board_title}`));
      },
      getChartData() {
        this.chartData = {};
        this.$axios.get('supervisor/dashboard/chart').then(res=>{
          if(res.status===200){
            this.chartData = res.data;
          }
        })
      },
      clickPopulate(item) {
        this.routerPush(`product/create?id=${item.id}`);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-content-box
  .lp-more
  .lp-notice-content
    cursor pointer

  .lp-chart-box
    background-color white
    padding-top 24px
    padding-bottom 24px

  .lp-dashboard-title
    padding 16px
    background-color white
    color #989898
    font-size 16px

  .lp-dashboard-content
    padding 16px 12px
    padding-top 0
    display flex
    background-color white

  .lp-content-box
    width 46%
    border 1px solid #eee
    margin 0 2% 8px 2%
    /*width 50%*/
    /*border 1px solid #eee*/
    /*margin 0 4px*/

  .lp-content-box:hover
    background-color #eee

  .lp-light-black
  .lp-light-grey
    font-size 12px

  .lp-light-black
    color #333333

  .lp-light-grey
    color #989898

  .lp-btn-setting
    cursor pointer
    margin-left 12px

  .lp-content-box-title
    text-align center
    padding-top 16px
    font-size 12px

  .lp-content-box-data
    padding 16px
    text-align center

  .lp-content-box-data
    color $primary
    font-size 26px
    font-weight bold

  .lp-dashboard-table
    width 100%
    background-color white

  .lp-dashboard-table th
  .lp-dashboard-table td
    text-align center !important
    font-size 12px

  .lp-dashboard-table th
    font-weight unset

  .lp-dashboard-table tr
    height 40px
    line-height 40px

  .lp-service-charge
    border-radius 24px
    padding 4px
    font-size 12px
    background-color #eee
    text-align center
    color #333

  .lp-more
    font-size 12px
    line-height 12px

  .lp-notice-content
    background-color white
    padding 16px

  .lp-site-analytics
    background-color rgb(255, 120, 77)
    width 124px
    height 32px
    text-align center
    line-height 32px
    font-size 12px
    color white
    border-radius 3px

  .lp-background:hover
    background-color #eee

  /*.dashboard-div
    margin-bottom 80px !important

  @media(max-width:768px)
    .dashboard-div
      margin-bottom 578px !important*/

  .tab-item
    padding 4px 12px
    margin-right 8px
  .tab-item-selected
    background-color #ff5722
    color white
    border-radius 30px

  .select-partner
    background white
    border 1px solid #ddd
    padding 4px 12px
    border-radius 30px
    select
      border 0

  .panel-tab
    background-color white
    display flex
    flex-wrap wrap
    padding 12px
  .panel-tab-item
    padding 4px 12px
    font-size 14px
    color #777

  .panel-tab-item-selected
    background-color #ff5722
    border-radius 30px
    color white

  .lp-panel-box
    border 1px solid #eee
    border-right 0
    cursor pointer
    padding 20px 0
    text-align center
  .lp-panel-box:last-child
    border-right 1px solid #eee

  .lp-panel-box:hover
    background-color #f5f5f5

  .panel-daily-title
    font-size 14px
    margin-bottom 4px
  .panel-daily-price
    font-size 26px

  .lp-panel-content
    padding 4px
    width 20%

  @media(max-width:768px)
    .panel-daily-title
      font-size 12px
    .panel-daily-price
      font-size 16px

    .lp-panel-content
      width 50%

  .card-top-product
    display flex
    padding 6px 20px 6px 0
    border-bottom 1px solid #dddddd
    align-items center
    font-size 12px
    color #4a4a4a
  .card-top-product-partner-name
    color #9b9b9b
  .card-top-product:hover
    background-color #f5f5f5
</style>
